import React, { useState } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Text, CheckBox } from 'src/Components'
import Copy from './Copy'

import styles from './OutreachOption.module.scss'

const propTypes = {
  className: PropTypes.string,
  extreme: PropTypes.bool,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

const Left = props => <div className={styles.left} {...props} />

const Right = props => <div className={styles.right} {...props} />

const OutreachOption = ({
  className,
  amount,
  extreme,
  checked,
  high,
  low,
  ...restProps
}) => {
  const [isClicked, setIsClicked] = useState(checked)

  const handleClick = () => {
    setIsClicked(!isClicked)
  }

  const handleKeyPress = e => {
    e.preventDefault()
    if (e.key === 'Enter') {
      setIsClicked(!isClicked)
    }
  }

  return (
    <div
      className={classnames(
        styles.root,
        isClicked && styles.checked,
        className
      )}
      role='button'
      tabIndex={0}
      onClick={() => handleClick()}
      onKeyPress={e => handleKeyPress(e)}
    >
      <Left>
        <CheckBox.Pink hideLabel checked={isClicked} {...restProps}>
          <Copy.Head extreme={extreme} />
        </CheckBox.Pink>
      </Left>

      <Right>
        <Text size='m' className={styles.headline}>
          <Copy.Head extreme={extreme} high={high} low={low} />
        </Text>
        <Text size='s' color='quiet'>
          <Copy.Body extreme={extreme} amount={amount} />
        </Text>
      </Right>
    </div>
  )
}

OutreachOption.propTypes = propTypes

export default OutreachOption
